export interface DefectDojoProduct {
  id: number;
  name: string;
  description: string;
  prod_type: number;
  prod_type_name?: string;
  created: string; // ISO 8601
  findings_count: number;
  findings_list: number[];
}

export interface Finding {
  id: number;
  title: string;
  severity: Severity;
  status: FindingStatus;
  active: boolean;
  verified: boolean;
  false_p: boolean;
  is_mitigated: boolean;
  date: string; // ISO 8601
  component_name: string | null;
  component_version: string | null;
  description: string;
  test: number;
  found_by: number[];
}

export type Severity = 'Critical' | 'High' | 'Medium' | 'Low' | 'Informational';

export type FindingStatus =
  | 'Active'
  | 'Verified'
  | 'False Positive'
  | 'Mitigated'
  | 'Out of Scope'
  | 'Risk Accepted';

export interface Engagement {
  id: number;
  name: string;
  engagement_type: 'Interactive' | 'CI/CD';
  status: string;
  target_start: string;
  target_end: string;
  created: string;
  updated: string;
  product: number;
}

export interface PaginationParams {
  limit?: number;
  offset?: number;
}

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const SEVERITY_COLORS: Record<Severity, string> = {
  Critical: '#d32f2f',
  High: '#f57c00',
  Medium: '#fbc02d',
  Low: '#1976d2',
  Informational: '#9e9e9e',
};

export const SEVERITY_ORDER: Severity[] = [
  'Critical',
  'High',
  'Medium',
  'Low',
  'Informational',
];

export function deriveStatus(f: Pick<Finding, 'active' | 'verified' | 'false_p' | 'is_mitigated'>): FindingStatus {
  if (f.false_p) return 'False Positive';
  if (f.is_mitigated) return 'Mitigated';
  if (f.verified) return 'Verified';
  if (f.active) return 'Active';
  return 'Active';
}

